import { FC } from 'react'
import { ColoursObj, Typography } from '@eventr/common-storybook'
import { Box, Slider } from '@mui/material'
import { useEphemeralStore } from '../../../state/useEphemeralStore'
import { useShallow } from 'zustand/react/shallow'

const marks = [
    {
        value: 100,
        label: (
            <Typography color={ColoursObj.font.secondary + ' !important'}>
                100
            </Typography>
        ),
    },
    {
        value: 500,
        label: (
            <Typography color={ColoursObj.font.secondary + ' !important'}>
                500
            </Typography>
        ),
    },
    {
        value: 1000,
        label: (
            <Typography color={ColoursObj.font.secondary + ' !important'}>
                1000
            </Typography>
        ),
    },
]

export const PriceRangeFilter: FC = () => {
    const { filtersObj, setFiltersObj } = useEphemeralStore(
        useShallow((s) => ({
            filtersObj: s.filtersObj,
            setFiltersObj: s.setFiltersObj,
        }))
    )

    return (
        <Box>
            <Typography variant="bodySubtext" color={ColoursObj.font.secondary}>
                Price Range: {filtersObj.priceRange[0]} {' - '}{' '}
                {filtersObj.priceRange[1]}
            </Typography>
            <Box padding={'0 8px'}>
                <Slider
                    value={filtersObj.priceRange}
                    disableSwap
                    valueLabelDisplay="auto"
                    min={0}
                    max={3000}
                    marks={marks}
                    onChange={(event, value, active) => {
                        if (active === 0) {
                            setFiltersObj({
                                ...filtersObj,
                                priceRange: [
                                    value[0],
                                    filtersObj.priceRange[1],
                                ],
                            })
                        }
                        if (active === 1) {
                            setFiltersObj({
                                ...filtersObj,
                                priceRange: [
                                    filtersObj.priceRange[0],
                                    value[1],
                                ],
                            })
                        }
                    }}
                    color={'secondary'}
                />
            </Box>
        </Box>
    )
}
